import { useCallback } from 'react'

import SubscriptionEvents from 'Pods/Shared/Constants/subscriptionEvents'
import useTracker from 'Pods/Shared/Hooks/useTracker'

const PAGE_TYPE = 'homepage'

export const CTA_CLICK_FLUSH_TIMEOUT_MS = 1000

const useSubscriptionPromoTracking = () => {
  const { trackEvent } = useTracker()

  const trackImpression = useCallback(() => {
    trackEvent(SubscriptionEvents.PROMO_BANNER_IMPRESSION, { page_type: PAGE_TYPE })
  }, [trackEvent])

  const trackCtaClick = useCallback((entryPoint, onComplete) => {
    trackEvent(
      SubscriptionEvents.PROMO_BANNER_CTA_CLICK,
      {
        page_type: PAGE_TYPE,
        ...(entryPoint && { entry_point: entryPoint }),
      },
      typeof onComplete === 'function'
        ? { eventCallback: onComplete, eventTimeout: CTA_CLICK_FLUSH_TIMEOUT_MS }
        : {}
    )
  }, [trackEvent])

  return {
    trackImpression,
    trackCtaClick,
  }
}

export default useSubscriptionPromoTracking
